"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webcom = _interopRequireDefault(require("webcom/webcom"));

var _Config = _interopRequireDefault(require("../Config"));

var _StreamManager = _interopRequireDefault(require("../stream/StreamManager"));

var _PeerConnectionManager = _interopRequireDefault(require("../webrtc/PeerConnectionManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * singleton
 * @type {CacheManager}
 * @private
 */
var _cache = null;
/**
 * Singleton to handle global references
 * @access protected
 */

var CacheManager =
/*#__PURE__*/
function () {
  /**
   * Construct singleton
   * @return {CacheManager}
   */
  function CacheManager() {
    _classCallCheck(this, CacheManager);

    if (!_cache) {
      _cache = this;
    }

    return _cache;
  }
  /**
   * The base reference
   * @param {Webcom} url the reference or its url
   */


  _createClass(CacheManager, [{
    key: "base",
    set: function set(url) {
      /**
       * @ignore
       */
      this._base = url instanceof _webcom.default ? url : new _webcom.default(url);
    }
    /**
     * The base reference
     * @type {Webcom}
     */
    ,
    get: function get() {
      return this._base;
    }
    /**
     * The connected user
     * @param {Config} config the connected user
     */

  }, {
    key: "config",
    set: function set(config) {
      if (!this._config) {
        /**
         * @ignore
         */
        this._config = new _Config.default(config);
      } else {
        this._config.assign(config);
      }
    }
    /**
     * The connected user
     * @type {Config}
     */
    ,
    get: function get() {
      if (!this._config) {
        this._config = new _Config.default();
      }

      return this._config;
    }
    /**
     * The connected user
     * @param {User} user the connected user
     */

  }, {
    key: "user",
    set: function set(user) {
      /**
       * @ignore
       */
      this._user = user;
    }
    /**
     * The connected user
     * @type {User}
     */
    ,
    get: function get() {
      return this._user;
    }
    /**
     * The current device
     * @param {string} device the current device
     */

  }, {
    key: "device",
    set: function set(device) {
      /**
       * @ignore
       */
      this._device = device;
    }
    /**
     * The current device
     * @type {string}
     */
    ,
    get: function get() {
      return this._device;
    }
    /**
     * The log level (DEBUG, INFO, WARN, ERROR)
     * @type {string}
     */

  }, {
    key: "logLevel",
    set: function set(level) {
      if (/^DEBUG|INFO|WARN|ERROR$/i.test(level)) {
        /**
         * @ignore
         */
        this._logLevel = level;
      } else if (level) {
        throw new Error('Unsupported log level (DEBUG, INFO, WARN, ERROR)');
      }
    }
    /**
     * The log level (DEBUG, INFO, WARN, ERROR)
     * @returns {string}
     */
    ,
    get: function get() {
      return this._logLevel || 'ERROR';
    }
    /**
     * Streams manager
     * @returns {StreamManager}
     */

  }, {
    key: "streams",
    get: function get() {
      if (!this._streams) {
        /**
         * @ignore
         */
        this._streams = new _StreamManager.default();
      }

      return this._streams;
    }
    /**
     * PeerConnections manager
     * @returns {PeerConnectionManager}
     */

  }, {
    key: "peerConnections",
    get: function get() {
      if (!this._peerConnections) {
        /**
         * @ignore
         */
        this._peerConnections = new _PeerConnectionManager.default();
      }

      return this._peerConnections;
    }
    /**
     *
     * @param room
     */

  }, {
    key: "room",
    set: function set(room) {
      this._room = room;
    }
    /**
     *
     * @returns {*}
     */
    ,
    get: function get() {
      return this._room;
    }
  }]);

  return CacheManager;
}();
/**
 * The singleton instance
 * @ignore
 * @type {CacheManager}
 */


var cache = new CacheManager();
/**
 * Singleton for shared references
 * @access protected
 */

var _default = cache;
exports.default = _default;